import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newDocument({ commit }) {
    let truckDocument = {
      truck_id: $(".truck_id").val(),
      truck_log: ('.truck_log', document.getElementById('truckLogInput').files[0]),
      trailer_log: $(".trailer_log").val()
    };
  //   let formData = new FormData();
  // formData.append('truck_id', $(".truck_id").val());
  // formData.append('truck_log', document.getElementById('truckLogInput').files[0]);
  // formData.append('trailer_log', $(".trailer_log").val());

  console.log(truckDocument);
    $(".creatingTruckdocuments").hide();
    $(".creatingTruckdocumentsLoader").show();
    baseurl.post(rt.newDocument, truckDocument,   {
      headers: {
        'Content-Type': 'multipart/form-data' // Set content type explicitly
      }
    }).then(res => {
      $(".creatingTruckdocuments").show();
      $(".creatingTruckdocumentsLoader").hide();

      if (res.data.code === 200) {
        suc.truckdocumentCreateSuccess();
        commit("STORE_TRUCK_DOCUMENTS", res.data.truckdocuments);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.TruckdocumentExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingTruckdocument();
      } else if (res.data.code === 405) {
        ers.noPermissionToCreate();
        router.push("/managetrucks");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/truckdocuments/actions.js